function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { getSpotlightStyles, titleFontSizesBOH } from '../../helpers/utils';
import { Textfit } from 'react-textfit';
const HeaderLeaderboard = ({
  text,
  metadata,
  description
}) => {
  const {
    body_color,
    titleStyle,
    title_font_family
  } = getSpotlightStyles(metadata, text);
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: titleStyle
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.large
  }, text.title)), /*#__PURE__*/React.createElement("p", {
    style: {
      color: body_color
    },
    className: "description"
  }, description));
};
const HeaderNonLeaderboard = ({
  text,
  metadata,
  group_name,
  showUpdatedTime,
  hideTitle = false
}) => {
  const {
    logo
  } = metadata;
  const {
    body_color,
    titleStyle,
    title_font_family
  } = getSpotlightStyles(metadata, text);
  return /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    className: "logo",
    alt: "logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, !hideTitle && /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: titleStyle
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.medium
  }, text.title)), showUpdatedTime && /*#__PURE__*/React.createElement("p", {
    className: "updated-time",
    style: {
      color: body_color
    }
  }, group_name ? `By ${group_name} sales today,  updated ` : 'Updated ', "right now")));
};
const Header = props => props.isLeaderboard ? /*#__PURE__*/React.createElement(HeaderLeaderboard, _extends({
  props: true
}, props)) : /*#__PURE__*/React.createElement(HeaderNonLeaderboard, _extends({
  props: true
}, props));
export default Header;